import { render } from "./PeopleEnquiriesList.vue?vue&type=template&id=7020c254"
import script from "./PeopleEnquiriesList.vue?vue&type=script&lang=js"
export * from "./PeopleEnquiriesList.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__